import { Localized } from '@fluent/react';
import * as React from 'react';
import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';

import { getLanguageFromBrowser } from '../../../services/localization';

import './select-device.css';

interface IFormInput {
  device: string;
  devices: (string | boolean)[];
}

function SelectDevice({
  onSelectDevice,
  devices,
}: {
  onSelectDevice: (type: string, devices?: string[]) => void;
  devices: string[];
}): JSX.Element {
  const {
    register,
    handleSubmit,
    errors,
    setValue,
    setError,
    clearErrors,
    reset,
  } = useForm<IFormInput>();
  const [showDevices, setShowDevices] = useState(false);

  const onSubmit = (data: IFormInput) => {
    if (!data.devices || validateDevices(data.devices)) {
      return onSelectDevice(
        data.device.toLowerCase(),
        data.devices?.filter(i => i != false) as string[]
      );
    }
  };

  const onChangeDevice: React.ChangeEventHandler<HTMLSelectElement> = event => {
    if (event.target.value == 'integrated') {
      clearErrors('devices');
      setShowDevices(false);
    } else {
      setValue('devices', devices);
      reset({ device: 'external', devices: devices });
      setShowDevices(true);
    }
  };

  const validateDevices = (data: (string | boolean)[]) => {
    console.log(data);
    if (data.some(item => item != false)) {
      clearErrors('devices');
      return true;
    } else {
      setError('devices', { types: { minLength: false } });
    }
  };

  return (
    <>
      <div className="terms-container">
        <div className="terms-header">
          <div className="terms-header-text">
            <Localized id="recorder-title">
              <div />
            </Localized>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="title-and-action"></div>

            <div className="form-group">
              <Localized id="recorder-devices-label">
                <label />
              </Localized>
              <select
                ref={register({ required: 'Device is required.' })}
                name="device"
                onChange={onChangeDevice}
                defaultValue="">
                <Localized id="recorder-device-placeholder">
                  <option value="" disabled />
                </Localized>

                <Localized id="recorder-device-integrated">
                  <option value="integrated" />
                </Localized>

                <Localized id="recorder-device-external">
                  <option value="external" />
                </Localized>
              </select>
              {errors.device && (
                <Localized id="recorder-device-required">
                  <p className="form-validation">{errors.device.message}</p>
                </Localized>
              )}
              <Localized id="recorder-small-label">
                <p className="form-small" />
              </Localized>
              {showDevices && (
                <>
                  <Localized id="recorder-devices-list-label">
                    <label />
                  </Localized>
                  {devices.map((device, i) => (
                    <label key={i}>
                      <input
                        type={'checkbox'}
                        value={device}
                        name={`devices[${i}]`}
                        ref={register()}
                      />{' '}
                      {device}
                    </label>
                  ))}
                  {errors.devices && (
                    <Localized id="recorder-devices-list-required">
                      <p className="form-validation">{errors.devices}</p>
                    </Localized>
                  )}
                </>
              )}
            </div>

            <button className="button-submit" type="submit">
              Next
            </button>
          </form>
        </div>
      </div>
    </>
  );
}

export default SelectDevice;
